var cilLevelUp = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='80 384 80 416 296 416 296 78.627 380.687 163.314 403.313 140.686 280 17.373 156.687 140.686 179.313 163.314 264 78.627 264 384 80 384' class='ci-primary'/>"];

export { cilLevelUp };
//# sourceMappingURL=cil-level-up.js.map
